<template>
    <div class="billing-purchases-container">
        <div class="billing-purchases">
            <div class="products-heading">
                <h3>{{ $t("adminMenu.billingPurchases") }}</h3>
            </div>

            <div class="billing-wrapper section-wrap" v-if="billingData.length > 0">
                <h5>{{ $t("billingPurchases.subTitle") }}</h5>
                <bar-chart class="chart-wrap section-wrap" v-if="chartData.datasets.length" :data="chartData" />

                <CustomTable v-if="!isLoading" :profile="profile" title="Payments Log" :customObject="billingData" />
            </div>
            <MainLoader class="section-wrap" v-if="isLoading" />
            <div v-if="billingData.length === 0" class="billing-wrapper section-wrap">
                <h5>No billing data found</h5>
            </div>
        </div>

    </div>
</template>

<script>
import store from "../../services/vuex.js";
import auth from "../../services/auth.js";
import api from '../../services/apiEndpoints.js';
import CustomTable from "./general-components/CustomTable.vue";
import MainLoader from "./general-components/MainLoader.vue";
import eventBus from "../../services/eventBus.js";

import {
    Chart,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
} from "chart.js";

import { Bar } from "vue-chartjs";

// Register Chart.js components
Chart.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);


export default {
    data() {
        return {
            user: null,
            billingData: {},
            isLoading: false,
            chartData: {
                labels: [],
                datasets: [],
            },
            labels: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"], // Month keys
            datasets: [], // Will be populated dynamically
            colors: [    // Chart colors
                "rgba(75, 192, 192, 0.7)",
                "rgba(255, 159, 64, 0.7)",
                "rgba(54, 162, 235, 0.7)",
                "rgba(255, 99, 132, 0.7)",
                "rgba(153, 102, 255, 0.7)",
                "rgba(255, 205, 86, 0.7)"
            ],
            profile: {},
        };
    },
    computed: {
        adminDetails: {
            get() {
                return this.$store.state.adminDetails;
            },
            set(value) {
                this.$store.commit("setAdminDetails", value);
            },
        },
    },
    mounted() {
        this.user = auth.state.user;
        if (this.user) {
            this.getStylistBillingAndPurchases(this.user.id);
            this.getStylistDetails(this.user.id);
            this.getProfile();
        }
    },
    components: {
        CustomTable,
        MainLoader,
    },
    methods: {
        getStylistBillingAndPurchases(id) {
            this.isLoading = true;

            this.$http
                .get(api.actions.get_stylist_billing_and_purchases + id)
                .then(response => {
                    if (response.data.error) return;

                    // Process billing data
                    this.billingData = Object.entries(response.data.details)
                        .reverse()
                        .map(([year, months]) => {
                            const filteredMonths = {};

                            Object.entries(months).forEach(([month, transactions]) => {
                                const filteredTransactions = transactions.filter(t => t.amount_paid >= 1);
                                if (filteredTransactions.length > 0) {
                                    filteredMonths[month] = filteredTransactions;
                                }
                            });

                            return [year, filteredMonths];
                        })
                        // Remove years with no valid months left
                        .filter(([, months]) => Object.keys(months).length > 0);

                    this.chartData = this.transformBillingDataToChart(this.billingData);
                })
                .catch(error => {
                    console.error("Error fetching billing data:", error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        transformBillingDataToChart(data) {
            const datasets = [];

            data.forEach(([year, months], i) => {
                const color = this.colors[i % this.colors.length];
                const monthlyTotals = this.labels.map(month => {
                    if (!months[month]) return 0;
                    return months[month].reduce((sum, entry) => sum + (entry.amount_paid || 0), 0);
                });

                datasets.push({
                    label: year,
                    data: monthlyTotals,
                    backgroundColor: color,
                    borderColor: color.replace("0.7", "1"),
                    borderWidth: 2,
                });
            });

            return {
                labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                datasets
            };
        },
        getStylistDetails(id) {
            this.$http.get(api.actions.get_stylist_details + id).then(
                function (response) {
                    if (typeof response.data.details !== "undefined") {
                        let adminDetails = response.data.details;
                        this.$store.commit("setAdminDetails", adminDetails);
                        eventBus.emit("admin_details_loaded");
                    }
                }.bind(this)
            );
        },

        getProfile: function () {
            this.$http.get(api.actions.get_profile_info).then(
                function (response) {
                    if (typeof response.data.user_profile !== "undefined") {
                        this.profile = response.data.user_profile;
                    }
                }.bind(this)
            );
        },

    },
    components: {
        CustomTable,
        MainLoader,
        BarChart: Bar,
    },
};
</script>
